import ReactGA from 'react-ga4';

import LoggerService from '../service/LoggerService';

const gaKey = process.env.REACT_APP_GA_KEY;

export const gaActionTypes = {
    messages: {
        sent: 'Message Sent',
        received: 'Message Received'
    },
    user: {
        login: 'User login',
        logout: 'User logout',
        signup: 'User signup',
        delete: 'User delete',
        startChat: 'User start chat'
    },
    payments: {
        bannerType: 'User_clicked_on_start_trial_button_in_banner',
        triggerPopup: 'User_triggered_payment_popup_in_chat',
        popupButtons: 'User_go_to_payment_page_form_popup_button',
        profileButtons: 'User_go_to_payment_page_from_the_button_on_profile_page',
        issueNotification: 'User_go_to_retry_payment_from_issue_notification_in_the_chat',
        submitPayment: {
            googlePay: 'User_clicked_on_googlePay_payment_button',
            applePay: 'User_clicked_on_applePay_payment_button',
            creditCard: 'User_submitted_credit_card_payment'
        }
    }
};

export const gaCategoryTypes = {
    message: 'Message',
    user: 'User',
    payments: 'Payments'
};

export const gaLabelTypes = {
    successful: 'Successful'
};
class GoogleAnalytics {
    constructor() {
        if (this._instance) {
            return this._instance;
        }
        this._instance = this;
    }

    init() {
        if (!gaKey) {
            LoggerService.log('GoogleAnalytics gaKey key is not available');
            return;
        }
        ReactGA.initialize(gaKey);
    }

    eventInit(actionType, actionCategory, label = '') {
        if (!gaKey) {
            return;
        }
        ReactGA.event({
            action: actionType,
            category: actionCategory,
            label
        });
    }
}

export default new GoogleAnalytics();
